/**
 * The game's colours, defined once. Canvas (PixiJS) colours are numbers; the
 * start screen and the end panel are DOM, so their colours are CSS strings.
 * No imports, so the tests and both renderers can use it.
 */

// canvas
export const SKY_INK = 0x23332F; // text drawn over the sky, and outlines
export const WEEL_LIME = 0xD3F009;
export const PALE_LIME = 0xF4FFB0;
export const PAPER = 0xF1F5F0;
export const WHITE = 0xFFFFFF;
export const GREY = 0x96A09E;

/**
 * A canvas colour as a CSS string.
 * @param {number} color e.g. 0x23332F
 * @returns {string} e.g. '#23332F'
 */
export function css(color) {
  return '#' + color.toString(16).padStart(6, '0').toUpperCase();
}

// DOM screens
export const UI = {
  INK: '#131F2E',
  LIME: '#CAEE10',
  PAPER: css(PAPER),
  PICKED_BG: '#262626',
  SLATE: '#37474F',
  MIST: '#B0BEC5',
  ERROR: '#C62828',
  OK: '#0C5C2E',
  CTA: '#C8F04B'
};
